export interface TickerOption {
  label: string
  bbgCompositeKey: string
  name: string
  legalName: string
  value: string
  status: string
}

const T_PREFIX = 'idea_list.idea_modal.action_idea_form'

export const IDEA_MUTATION_KEYS = {
  CREATE: 'create-idea',
  UPDATE: 'update-idea',
} as const

export const getTradeReasonsTreeData = (t: (key: string) => string) => [
  {
    value: 'Earnings event',
    title: t(`${T_PREFIX}.trade_reason_earnings_event`),
    disabled: true,
    children: [
      {
        value: 'Betting into earnings report',
        title: t(`${T_PREFIX}.trade_reason_betting_into_earnings`),
      },
      {
        value: 'Price under/over-react post earnings',
        title: t(`${T_PREFIX}.trade_reason_price_react_post_earnings`),
      },
    ],
  },
  {
    value: 'Events/Catalyst (none-earning)',
    title: t(`${T_PREFIX}.trade_reason_events_catalyst`),
    disabled: true,
    children: [
      {
        value: 'Betting into event/catalyst',
        title: t(`${T_PREFIX}.trade_reason_betting_into_event`),
      },
      {
        value: 'Price under/over-react post event/catalyst',
        title: t(`${T_PREFIX}.trade_reason_price_react_post_event`),
      },
    ],
  },
  {
    value: 'Company fundamentals',
    title: t(`${T_PREFIX}.trade_reason_company_fundamentals`),
    disabled: true,
    children: [
      {
        value: 'Long term earnings',
        title: t(`${T_PREFIX}.trade_reason_long_term_earnings`),
      },
      {
        value: 'Own firm research',
        title: t(`${T_PREFIX}.trade_reason_own_firm_research`),
      },
      {
        value: 'Other firm research',
        title: t(`${T_PREFIX}.trade_reason_other_firm_research`),
      },
    ],
  },
  {
    value: 'others',
    title: t(`${T_PREFIX}.trade_reason_others`),
    disabled: true,
    children: [
      {
        value: 'Thematic',
        title: t(`${T_PREFIX}.trade_reason_thematic`),
      },
      {
        value: 'Technical analysis',
        title: t(`${T_PREFIX}.trade_reason_technical_analysis`),
      },
      {
        value: 'Flows',
        title: t(`${T_PREFIX}.trade_reason_flows`),
      },
      {
        value: 'Macro',
        title: t(`${T_PREFIX}.trade_reason_macro`),
      },
      {
        value: 'Hedging (Funding Long/Funding Short)',
        title: t(`${T_PREFIX}.trade_reason_hedging`),
      },
      {
        value: 'Regulation (compliance/delisting/sanction)',
        title: t(`${T_PREFIX}.trade_reason_regulation`),
      },
    ],
  },
]

export const FillStrategies = [
  { value: '1hour-VWAP', labelKey: `${T_PREFIX}.fill_strategy_1hr_vwap` },
  {
    value: 'Fullday-VWAP',
    labelKey: `${T_PREFIX}.fill_strategy_vwap_till_eod`,
  },
]

export const HorizonOptions = [
  {
    value: 'Intraday',
    labelKey: 'idea_list.idea_modal.action_idea_form.horizon_intraday',
  },
  {
    value: '1-4 Days',
    labelKey: 'idea_list.idea_modal.action_idea_form.horizon_1_4_days',
  },
  {
    value: '1-2 Weeks',
    labelKey: 'idea_list.idea_modal.action_idea_form.horizon_1_2_weeks',
  },
  {
    value: '2-4 Weeks',
    labelKey: 'idea_list.idea_modal.action_idea_form.horizon_2_4_weeks',
  },
  {
    value: '1-3 Months',
    labelKey: 'idea_list.idea_modal.action_idea_form.horizon_1_3_months',
  },
  {
    value: 'Quarter',
    labelKey: 'idea_list.idea_modal.action_idea_form.horizon_quarter',
  },
]

export const ConvictionOptions = [
  {
    value: 'Very High',
    labelKey: 'idea_list.idea_modal.action_idea_form.conviction_very_high',
  },
  {
    value: 'High',
    labelKey: 'idea_list.idea_modal.action_idea_form.conviction_high',
  },
  {
    value: 'Medium',
    labelKey: 'idea_list.idea_modal.action_idea_form.conviction_medium',
  },
  {
    value: 'Low',
    labelKey: 'idea_list.idea_modal.action_idea_form.conviction_low',
  },
]
